import {ExtendedShiftQuickSelectSlots} from '@hconnect/common/types'

// Slots supported by getPlantEntryPointQuickSelectFilter / useAreaDefaultPlantTimeRange
export const AREA_QUICK_SELECT_SLOTS: ExtendedShiftQuickSelectSlots[] = [
  'today',
  'yesterday',
  'last7days',
  'currentMonth',
  'lastMonth'
]

// URL search param holding the area dashboard's selected time range slot
export const AREA_TIME_RANGE_PARAM = 'timeRangeArea'
